import React from "react";
import { Box, Typography, Grid, Paper, Stack } from "@mui/material";
import { useLogger } from "../../../../contexts/LoggerContext";
import { useSchemes } from "../../../../contexts/SchemesContext";
import {
  PuntReturnPlayLog,
  PuntReturnPlaySelection,
} from "../../../../types/LogTypes";
import { jerseyNumberNameDisplay } from "../../../../helpers/helpers";

export const PuntReturnDetails = () => {
  const { currentPlayCall, currentPlayLog, currentPlayPenalty } = useLogger();
  const { puntReturnPersonnel, puntReturnPlays } = useSchemes();

  const playCall = currentPlayCall as PuntReturnPlaySelection | null;
  const playLog = currentPlayLog as PuntReturnPlayLog | null;

  const personnel_group = playCall
    ? puntReturnPersonnel.find((p) => p.id === playCall.personnel_group_id)
    : null;

  const play = playCall
    ? puntReturnPlays.find((p) => p.id === playCall.play_id)
    : null;

  const CalculateGridSize = () => {
    if (currentPlayPenalty) {
      return 4;
    }
    return 6;
  };
  return (
    <Box sx={{ width: "100%" }}>
      <Grid container spacing={3}>
        {/* Play Call Section */}
        <Grid item xs={12} md={CalculateGridSize()}>
          <Paper
            elevation={2}
            sx={{
              p: 3,
              height: "100%",
              backgroundColor: "background.paper",
              borderRadius: 2,
            }}
          >
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Play Call
            </Typography>
            <Stack spacing={2}>
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  Personnel
                </Typography>
                <Typography variant="h6">
                  {personnel_group?.name || ""}
                </Typography>
              </Box>
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  Play
                </Typography>
                <Typography variant="h6">{play?.name || ""}</Typography>
              </Box>
            </Stack>
          </Paper>
        </Grid>

        {/* Play Result Section */}
        <Grid item xs={12} md={CalculateGridSize()}>
          <Paper
            elevation={2}
            sx={{
              p: 3,
              height: "100%",
              backgroundColor: "background.paper",
              borderRadius: 2,
              position: "relative",
            }}
          >
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Play Result
            </Typography>

            {playLog && (
              <Stack spacing={2}>
                {/* Returner */}
                {playLog.returner_roster_player && (
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">
                      Returner
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {jerseyNumberNameDisplay(playLog.returner_roster_player)}
                    </Typography>
                  </Box>
                )}

                {/* Punt Details */}
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Punt Details
                  </Typography>
                  <Typography variant="body1">
                    From: {playLog.punt_from} yard line
                  </Typography>
                  <Typography variant="body1">
                    To: {playLog.punt_to} yard line
                  </Typography>
                  <Typography variant="body1" sx={{ mt: 1 }}>
                    Punt Distance: {playLog.punt_yardage} yards
                  </Typography>
                </Box>

                {/* Return Details */}
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Return Details
                  </Typography>
                  <Typography variant="body1">
                    Returned To: {playLog.return_to_yardline} yard line
                  </Typography>
                  <Typography
                    variant="h5"
                    color={
                      playLog.return_yardage > 0 ? "success.main" : "error.main"
                    }
                    sx={{ mt: 1 }}
                  >
                    {playLog.return_yardage > 0 ? "+" : ""}
                    {playLog.return_yardage} return yards
                  </Typography>
                </Box>

                {/* Fumble Section */}
                {playLog.fumble && (
                  <Box
                    sx={{
                      mt: 2,
                      p: 1.5,
                      backgroundColor: "error.main",
                      color: "error.contrastText",
                      borderRadius: 1,
                    }}
                  >
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                      FUMBLE
                    </Typography>
                    {playLog.fumble.fumble_roster_player && (
                      <Typography variant="body2">
                        Fumbled by:{" "}
                        {jerseyNumberNameDisplay(
                          playLog.fumble.fumble_roster_player
                        )}
                      </Typography>
                    )}
                    {playLog.fumble.fumble_recovery_roster_player && (
                      <Typography variant="body2">
                        Recovered by:{" "}
                        {jerseyNumberNameDisplay(
                          playLog.fumble.fumble_recovery_roster_player
                        )}
                      </Typography>
                    )}
                  </Box>
                )}
              </Stack>
            )}
          </Paper>
        </Grid>

        {/* Penalties Section */}
        {currentPlayPenalty && (
          <Grid item xs={12} md={CalculateGridSize()}>
            <Paper
              elevation={2}
              sx={{
                p: 3,
                backgroundColor: "warning.light",
                borderRadius: 2,
              }}
            >
              <Typography
                variant="h6"
                sx={{ color: "warning.dark", fontWeight: 600 }}
              >
                Penalties
              </Typography>
              {/* Add penalty details here */}
            </Paper>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
